import {
  getUserData,
  setIsLoggedInData,
  setUserCedData,
  setUserIDData,
  setEventCodeData,
  setUserOtherData,
  setUsernameData,
  setHasSeenTutorialData,
  setEventNameData,
  setEventStartDateData,
  setEventEndDateData,
  setEventLocationData
} from '../dataApi';
import FavoritesService from '../../services/FavoritesService';
import { ActionType } from '../../util/types';
import { UserState } from './user.state';


export const loadUserData = () => async (dispatch: React.Dispatch<any>) => {
  dispatch(setLoading(true));
  const data = await getUserData();
  dispatch(setData(data));
  dispatch(setLoading(false));
}

export const setLoading = (isLoading: boolean) => ({
  type: 'set-user-loading',
  isLoading
} as const);

export const setData = (data: Partial<UserState>) => ({
  type: 'set-user-data',
  data
} as const);

export const logoutUser = () => async (dispatch: React.Dispatch<any>) => {
  console.log("cerrando sesion");

  // Limpiar servicio de favoritos
  const favoritesService = FavoritesService.getInstance();
  favoritesService.cleanup();

  await setIsLoggedInData(false);
  dispatch(setUsername());
  dispatch(setUserCed());
  dispatch(setUserID());
  dispatch(setUserOther());
  dispatch(setEventCode());
  dispatch(setEventName());
  dispatch(setEventStartDate());
  dispatch(setEventEndDate());
  dispatch(setEventLocation());
};

export const setIsLoggedIn = (loggedIn: boolean) => async (dispatch: React.Dispatch<any>) => {
  await setIsLoggedInData(loggedIn);
  return ({
    type: 'set-is-loggedin',
    loggedIn
  } as const)
};

export const setUsername = (username?: string) => async (dispatch: React.Dispatch<any>) => {
  await setUsernameData(username);
  return ({
    type: 'set-username',
    username
  } as const);
};

export const setUserCed = (userced?: string) => async (dispatch: React.Dispatch<any>) => {
  await setUserCedData(userced);
  return ({
    type: 'set-userced',
    userced
  } as const);
};

export const setUserID = (userid?: string) => async (dispatch: React.Dispatch<any>) => {
  await setUserIDData(userid);
  return ({
    type: 'set-userid',
    userid
  } as const);
};

export const setUserOther = (userother?: string) => async (dispatch: React.Dispatch<any>) => {
  await setUserOtherData(userother);
  return ({
    type: 'set-userother',
    userother
  } as const);
};

export const setEventCode = (eventcode?: string) => async (dispatch: React.Dispatch<any>) => {
  await setEventCodeData(eventcode);
  return ({
    type: 'set-eventcode',
    eventcode
  } as const);
};

export const setEventName = (eventName?: string) => async (dispatch: React.Dispatch<any>) => {
  await setEventNameData(eventName);
  return ({
    type: 'set-event-name',
    eventName
  } as const);
};

export const setEventStartDate = (eventStartDate?: string) => async (dispatch: React.Dispatch<any>) => {
  await setEventStartDateData(eventStartDate);
  return ({
    type: 'set-event-start-date',
    eventStartDate
  } as const);
};

export const setEventEndDate = (eventEndDate?: string) => async (dispatch: React.Dispatch<any>) => {
  await setEventEndDateData(eventEndDate);
  return ({
    type: 'set-event-end-date',
    eventEndDate
  } as const);
};

export const setEventLocation = (eventLocation?: string) => async (dispatch: React.Dispatch<any>) => {
  await setEventLocationData(eventLocation);
  return ({
    type: 'set-event-location',
    eventLocation
  } as const);
};

export const setHasSeenTutorial = (hasSeenTutorial: boolean) => async (dispatch: React.Dispatch<any>) => {
  await setHasSeenTutorialData(hasSeenTutorial);
  return ({
    type: 'set-has-seen-tutorial',
    hasSeenTutorial
  } as const);
}

export const setDarkMode = (darkMode: boolean) => ({
  type: 'set-dark-mode',
  darkMode
} as const);

// Nuevas acciones para campos de perfil
export const setEmail = (email?: string) => ({
  type: 'set-email',
  email
} as const);

export const setPhone = (phone?: string) => ({
  type: 'set-phone',
  phone
} as const);

export const setCompany = (company?: string) => ({
  type: 'set-company',
  company
} as const);

export const setPosition = (position?: string) => ({
  type: 'set-position',
  position
} as const);

export const setProfilePhotoUrl = (profilePhotoUrl?: string) => ({
  type: 'set-profile-photo-url',
  profilePhotoUrl
} as const);

export type UserActions =
  | ActionType<typeof setLoading>
  | ActionType<typeof setData>
  | ActionType<typeof setIsLoggedIn>
  | ActionType<typeof setUsername>
  | ActionType<typeof setUserCed>
  | ActionType<typeof setUserID>
  | ActionType<typeof setUserOther>
  | ActionType<typeof setHasSeenTutorial>
  | ActionType<typeof setDarkMode>
  | ActionType<typeof setEventCode>
  | ActionType<typeof setEventName>
  | ActionType<typeof setEventStartDate>
  | ActionType<typeof setEventEndDate>
  | ActionType<typeof setEventLocation>
  | ActionType<typeof setEmail>
  | ActionType<typeof setPhone>
  | ActionType<typeof setCompany>
  | ActionType<typeof setPosition>
  | ActionType<typeof setProfilePhotoUrl>
